//@ts-nocheck

const header = (): void => {
  const openBtn = document.querySelector(".js-open-nav-btn");
  const closeBtn = document.querySelector(".js-close-nav-btn");
  const header = document.querySelector(".js-header");
  stickyHeader();

  if (!header || !openBtn || !closeBtn) return;

  const navigationWrapper = header.querySelector(".js-navigation-wrapper");

  const disabledLinks = header.querySelectorAll(".disabled-click > a");
  if (disabledLinks.length > 0) {
    disabledLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        link.parentElement.classList.toggle("open-submenu");
      });
    });
  }

  openBtn.addEventListener("click", () => {
    document.body.style.overflow = "hidden";
    header.classList.add("open");
  });

  closeBtn.addEventListener("click", () => {
    document.body.style.overflow = null;
    header.classList.remove("open");
  });

  const menuItemsWithSubmenues = header.querySelectorAll(
    ".menu-item-has-children",
  );

  if (menuItemsWithSubmenues.length > 0) {
    menuItemsWithSubmenues.forEach((item) => {
      const link = item.querySelector("a");
      const submenu = item.querySelector("ul.sub-menu");
      if (!link || !submenu) return;

      const submenuLinks = submenu.querySelectorAll("li");
      if (submenuLinks) {
        submenu.style.gridTemplateRows = `repeat(${Math.ceil(submenuLinks.length / 2)}, auto)`;
      }

      const siblingElements = Array.from(item.parentElement.children);
      let hoverTimeout;
      item.addEventListener("mouseenter", () => {
        clearTimeout(hoverTimeout);
        item.classList.add("hovered");
        siblingElements.forEach((sibling) => {
          if (
            sibling !== item &&
            sibling.classList.contains("menu-item-has-children")
          ) {
            sibling.classList.remove("hovered");
          }
        });
      });
      item.addEventListener("mouseleave", () => {
        hoverTimeout = setTimeout(() => {
          item.classList.remove("hovered");
        }, 500);
      });
      item.addEventListener("focusin", () => {
        clearTimeout(hoverTimeout);
        item.classList.add("hovered");
        siblingElements.forEach((sibling) => {
          if (
            sibling !== item &&
            sibling.classList.contains("menu-item-has-children")
          ) {
            sibling.classList.remove("hovered");
          }
        });
      });
      item.addEventListener("focusout", () => {
        hoverTimeout = setTimeout(() => {
          item.classList.remove("hovered");
        }, 500);
      });

      const btn = document.createElement("button");
      btn.setAttribute("aria-label", "Dropdown Button");
      btn.classList.add("submenu-btn");
      link.append(btn);

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        item.classList.toggle("open-submenu");
      });
    });
  }
};

const stickyHeader = () => {
  const header = document.querySelector(".js-header");
  let prevPosY = window.scrollY;
  if (window.scrollY > 10) {
    header.classList.add("not-top");
  }

  addEventListener("scroll", () => {
    const posY = window.scrollY;
    if (posY < 10) {
      header.classList.remove("not-top");
    } else {
      header.classList.add("not-top");
    }
    prevPosY = posY;
  });
};

export default header;
